<template>
  <q-form ref="form" class="full-width">
    <div class="row">
      <div class="col q-pa-xs">
        <q-select
          label="Type"
          :readonly="forAssociation"
          v-model="formData.type"
          v-bind="siteCFG.fields.general"
          :options="typeOptions"
          option-label="label"
          option-value="value"
          map-options
          emit-value
        >
        </q-select>
      </div>
      <div v-if="formData.type" class="col-12 col-md-6 q-pa-xs">
        <q-select
          label="Role"
          v-model="formData.role"
          v-bind="siteCFG.fields.general"
          :options="roleOptions[formData.type]"
          option-label="label"
          option-value="value"
          map-options
          emit-value
        >
        </q-select>
      </div>
      <div
        v-if="formData.type == 'Association' && !forAssociation"
        class="col-12 q-pa-xs"
      >
        <assignAssociation
          :id="formData.ref_id"
          @changed="(val) => (formData.ref_id = val)"
        >
        </assignAssociation>
      </div>
    </div>
  </q-form>
</template>

<script>
  import { mapGetters } from "vuex";
  import assignAssociation from "@/components/associations/assignAssociation.vue";

  export default {
    components: {
      assignAssociation,
    },
    computed: {
      ...mapGetters({
        currentUser: "auth/currentUser",
        currentUserData: "auth/currentUserData",
        siteCFG: "settings/siteCFG",
        data: "users/permissionCurrent",
        dataLoading: "users/permissionCurrentLoading",
        typeOptions: "settings/userPermissionTypeOptions",
        roleOptions: "settings/userPermissionRoleOptions",
      }),
    },
    props: {
      id: {
        default: null,
      },
      forAssociation: {
        default: false,
        type: Boolean,
      },
    },
    watch: {
      data: function () {
        this.init();
      },
      id: function () {
        this.init();
      },
    },
    data: () => ({
      // Extra Data
      formData: {},
    }),
    beforeCreate() {
      this.$store.dispatch("associations/loadAll");
    },
    mounted() {
      this.init();
      if (this.id) {
        this.$store.dispatch("users/loadPermissionByID", this.id);
      }
    },
    methods: {
      init() {
        if (this.data && this.id && this.data.id == this.id) {
          this.formData = JSON.parse(JSON.stringify(this.data));
        } else {
          this.formData = {
            type: this.forAssociation ? "Association" : null,
            ref_id: this.forAssociation ? this.$route.params.id : null,
          };
        }
      },
      create(id) {
        this.$emit("loadingStateChanged", true);
        this.$refs.form.validate().then((result) => {
          if (result) {
            this.formData.users_id = id;
            this.$store
              .dispatch("users/userPermissionsNew", this.formData)
              .then((result) => {
                this.$emit("loadingStateChanged", false);
                if (result.Result == "Success") {
                  this.$emit("close", true);
                  this.formData = {};
                  this.$q.notify({
                    position: "top-right",
                    type: "positive",
                    message: result.Response.Message,
                  });
                } else {
                  this.$q.notify({
                    position: "top-right",
                    type: "negative",
                    message: result.Response.Message,
                  });
                }
              });
          } else {
            this.$emit("loadingStateChanged", false);
          }
        });
      },
      save() {
        this.$emit("loadingStateChanged", true);

        this.$store
          .dispatch("users/userPermissionsSave", this.formData)
          .then((result) => {
            this.$emit("loadingStateChanged", false);
            if (result.Result == "Success") {
              this.$emit("close", true);
              this.$q.notify({
                position: "top-right",
                type: "positive",
                message: "User has been saved",
              });
            } else {
              this.$q.notify({
                position: "top-right",
                type: "negative",
                message: "There was an Error, Please try again later",
              });
            }
          });
      },
    },
  };
</script>
